import * as $ from 'jquery';
import { Component, OnInit, Inject, Injector, forwardRef } from '@angular/core';
import { OntimizeService, dataServiceFactory, Util } from 'ontimize-web-ngx';
import { ODataTableColumnComponent, IDataTableCellRenderer } from '../o-datatable-column.component';
import { ODataTableComponent } from '../o-datatable.component';

export const DEFAULT_INPUTS_O_DATATABLE_CELL_RENDERER_SERVICE = [

  // service [string]: JEE service path. Default: no value.
  'service',

  // query-method [string]: name of the service method to perform queries. Default: query.
  'queryMethod: query-method',

  // entity [string]: entity of the service. Default: no value.
  'entity',

  // value-column [string]: value column (similar to 'cod' attribute of ComboReferenceDataField of classic Ontimize Desktop).
  //  Default: no value.
  'valueColumn: value-column',

  // columns [string]: columns of the entity, separated by ';'. Default: no value.
  'columns',

  // visible-columns [string]: visible columns, separated by ';'. Default: no value.
  'visibleColumns: visible-columns',

  // separator [string]: visible columns separator. Default: no value.
  'separator'
];


export class ODataTableCellRendererServiceComponent implements OnInit, IDataTableCellRenderer {

  public static DEFAULT_INPUTS_O_DATATABLE_CELL_RENDERER_SERVICE = DEFAULT_INPUTS_O_DATATABLE_CELL_RENDERER_SERVICE;

  protected service: string;
  protected dataService: any;
  protected componentData: any;
  protected entity: string;
  protected valueColumn: string;
  protected columns: string;
  protected dataColumns: Array<string>;
  protected visibleColumns: string;
  protected dataVisibleColumns: Array<string>;
  protected separator: string;
  protected queryMethod: string;

  constructor(  protected tableColumn: ODataTableColumnComponent,
    protected injector: Injector) {
    tableColumn.registerRenderer(this);
    this.componentData = {};
  }

  public ngOnInit() {
    this.tableColumn.updateRendererType('service');
    if (typeof (this.separator) === 'undefined') {
      this.separator = '';
    }
    if (typeof (this.queryMethod) === 'undefined') {
      this.queryMethod = 'query';
    }
    this.init(undefined);
  }

  public init(parameters: any) {
    if (typeof (parameters) !== 'undefined') {
      if (typeof (parameters.service) !== 'undefined') {
        this.service = parameters.service;
      }
      if (typeof (parameters.entity) !== 'undefined') {
        this.entity = parameters.entity;
      }
      if (typeof (parameters.valueColumn) !== 'undefined') {
        this.valueColumn = parameters.valueColumn;
      }
      if (typeof (parameters.columns) !== 'undefined') {
        this.columns = parameters.columns;
      }
      if (typeof (parameters.visibleColumns) !== 'undefined') {
        this.visibleColumns = parameters.visibleColumns;
      }
      if (typeof (parameters.separator) !== 'undefined') {
        this.separator = parameters.separator;
      }
      if (typeof (parameters.queryMethod) !== 'undefined') {
        this.queryMethod = parameters.queryMethod;
      }
    }
    if (this.columns) {
      this.dataColumns = this.columns.split(ODataTableComponent.COLUMNS_SEPARATOR);
    } else {
      this.dataColumns = [];
    }
    if (this.visibleColumns) {
      this.dataVisibleColumns = this.visibleColumns.split(ODataTableComponent.COLUMNS_SEPARATOR);
    } else {
      this.dataVisibleColumns = [];
    }

    // initialize data service
    this.dataService = this.injector.get(OntimizeService);
    if (Util.isDataService(this.dataService)) {
      let serviceCfg = this.dataService.getDefaultServiceConfiguration(this.service);
      if (this.entity) {
        serviceCfg['entity'] = this.entity;
      }
      this.dataService.configureService(serviceCfg);
    }

    // query service data
    if (this.dataService && (this.queryMethod in this.dataService) && this.entity && this.valueColumn) {
      this.dataService[this.queryMethod]({}, this.dataColumns, this.entity).subscribe(
        res => {
          let data = undefined;
          if (($ as any).isArray(res)) {
            data = res;
          } else if ((res.code === 0) && ($ as any).isArray(res.data)) {
            data = res.data;
          }
          if (($ as any).isArray(data)) {
            for (let i = 0; i < data.length; ++i) {
              let item = data[i];
              let key = item[this.valueColumn];
              if (typeof (key) !== 'undefined') {
                let value = '';
                for (let j = 0; j < this.dataVisibleColumns.length; ++j) {
                  let col = this.dataVisibleColumns[j];
                  if (typeof (item[col]) !== 'undefined') {
                    if (j > 0) {
                      value += this.separator;
                    }
                    value += String(item[col]);
                  }
                }
                this.componentData[key] = value;
              }
            }
          } else {
            console.log('[ODataTableCellRendererServiceComponent.init]: error code ' + res.code + ' when querying data');
          }
        },
        err => {
          console.log('[ODataTableCellRendererServiceComponent.init]: error', err);
        }
      );
    }
  }

  public render(data: any): string {
    return (typeof (this.componentData[data]) !== 'undefined') ? String(this.componentData[data]) : '';
  }

  public handleCreatedCell(cellElement: any, rowData: any) {
    // nothing to do here
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-datatable-cell-renderer-service',
  template: '',
  inputs: [
    ...DEFAULT_INPUTS_O_DATATABLE_CELL_RENDERER_SERVICE
  ],
  providers: [
    { provide: OntimizeService, useFactory: dataServiceFactory, deps: [Injector] }
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ODataTableColumnComponent, decorators: [{ type: Inject, args: [forwardRef(() => ODataTableColumnComponent), ] }, ]},
{type: Injector, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
